import * as React from "react"
import { Container, Row, Col } from "react-bootstrap"
import PageWrapper from "@app/components/PageWrapper"
import { redirect, useFetcher, useLoaderData } from "react-router-dom"
import SelectButton from "@app/components/Box/SelectButton"
import { setSetting } from "@app/models/settings"
import { getOffices } from "@app/models/office"
import Config from "@app/constants/Config"
import Textfield from "@app/components/Textfield"
import { useState } from "react"
import Box from "@app/components/Box/Box"

export async function action ({ request }) {
	const formData = await request.formData()
	await setSetting("officeId", formData.get("officeId"))
	return redirect(`${Config.BASE_PATH === "" ? "/" : Config.BASE_PATH}`)
}

export async function loader () {
	// load inspection form config
	const userOffices = await getOffices()
	if (!userOffices) {
		throw new Response("", {
			status: 500,
			statusText: "Offices not available",
		})
	}

	return { offices: userOffices }
}

function getSearchRegex (searchTerm) {
	const escaped = searchTerm.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
	return new RegExp(
		`(?:\\b${escaped}|(?<=\\W)${escaped}(?=[a-zäöüß-])|\\(${escaped}[^)]*\\))`,
		"i"
	)
}

export default function Offices () {
	let { offices } = useLoaderData()
	const fetcher = useFetcher()
	const [filter, setFilter] = useState("")

	if (filter) {
		offices = offices.filter(({
			ID,
			Branch
		}) => ID?.toString?.().startsWith?.(filter) || Branch.match(getSearchRegex(filter)))
	}

	const onSearch = (value) => {
		setFilter(value)
	}

	return (
		<PageWrapper valign={"center"}>
			<Container>
				<Row>
					<Col className={"mb-36"}>
						<h1 className={"mb-0"}>Niederlassungen</h1>
						<p className={"text-small text-dim"}>Wählen Sie eine Niederlassung aus:</p>
					</Col>
				</Row>
				<Row>
					<Col className={"mb-36"}>
						<Textfield name={"search"} label={"Suche"} onChange={(e) => onSearch(e?.target?.value)} />
					</Col>
				</Row>
				<Row>
					{offices.sort((a, b) => a.Branch > b.Branch ? 1 : -1).map((office, index) => (
						<Col xs={12} key={index}>
							<SelectButton
								headline={office.Branch}
								link={`${Config.BASE_PATH}/office/${office.officeId}`}
								onClick={() =>
									fetcher.submit(
										{ officeId: office.ID },
										{
											method: "post",
											encType: "application/x-www-form-urlencoded",
										},
									)
								}
							/>
						</Col>
					))}
				</Row>
			</Container>
		</PageWrapper>
	)
}
